const IMAGES = [
  {
    url: "https://images.pexels.com/photos/6872582/pexels-photo-6872582.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Sleek black luxury car with soapy foam",
    span: "md:col-span-7 md:row-span-2 h-[420px] md:h-auto",
  },
  {
    url: "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Black car splashing water during wash",
    span: "md:col-span-5 h-[260px]",
  },
  {
    url: "https://images.pexels.com/photos/6872151/pexels-photo-6872151.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Detailing a vehicle taillight",
    span: "md:col-span-5 h-[260px]",
  },
  {
    url: "https://images.pexels.com/photos/17855878/pexels-photo-17855878.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Lamborghini Huracán — the kind of car we love bringing back to showroom shine",
    span: "md:col-span-12 h-[360px]",
  },
  {
    url: "https://images.pexels.com/photos/6873015/pexels-photo-6873015.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Wiping down a car steering wheel during interior detail",
    span: "md:col-span-6 h-[280px]",
  },
  {
    url: "https://images.pexels.com/photos/6873100/pexels-photo-6873100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Deep interior clean of driver seat and console",
    span: "md:col-span-6 h-[280px]",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#09090B] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="font-display text-xs uppercase tracking-[0.3em] text-[#E10600] mb-3">
              / Work
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white">
              The Shine
              <br />
              Speaks For Itself.
            </h2>
          </div>
          <p className="font-body text-zinc-400 max-w-md">
            A peek at what your car could look like next weekend. Hand-finished
            results from Newcastle driveways.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 grid-flow-row-dense gap-4 md:gap-6">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden rounded-2xl border border-white/10 group ${img.span}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
